module.exports = __webpack_public_path__ + "img/2016.ce3aca62.png";